import { Chip } from "@mui/material";

import type { SecureProjectStatus } from "features/secureUploads/secureUploads";

/** OPEN in the brand's light teal, CLOSED in grey. */
export default function ProjectStatusChip({
  status,
}: {
  status: SecureProjectStatus;
}) {
  const open = status === "open";
  return (
    <Chip
      label={open ? "Open" : "Closed"}
      size="small"
      sx={{
        height: 20,
        fontSize: 11,
        fontWeight: 700,
        letterSpacing: "0.05em",
        textTransform: "uppercase",
        bgcolor: open ? "#E3F1F2" : "grey.200",
        color: open ? "#185059" : "text.secondary",
      }}
    />
  );
}
